import './utils.js';
import { faker } from 'https://cdn.jsdelivr.net/npm/@faker-js/faker/+esm';

/**
 * Initializes LogRocket for the microapp.
 */
const initLogRocket = () => {
  //window.emui.logRocketConfig.enable = false;
  // the appIds set in window variable and passed to initLogRocket are superceded by lrAppId in url params
  window.emui.logRocketConfig.appId = 'abcd';
  window.emuiLogrocket.initLogRocket({ appId: 'xyz', isReact: false });
};

/**
 * Event handler for the "lorem-ipsum-btn" button click event.
 */
const onLoremIpsumClick = () => {
  const loremIpsumText = document.getElementById('lorem-ipsum-text');
  loremIpsumText.textContent = faker.lorem.paragraph();
  loremIpsumText.style.color = `#${Math.floor(
    Math.random() * 16777215,
  ).toString(16)}`;
};

/**
 * Event handler for the window load event.
 */
const onLoad = () => {
  const loremIpsumBtn = document.getElementById('lorem-ipsum-btn');
  loremIpsumBtn.addEventListener('click', onLoremIpsumClick);
};

if (window.emuiLogrocket) initLogRocket();
window.addEventListener('load', onLoad);
